import axios from 'axios';

const service = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

let user = JSON.parse(localStorage.getItem('user'));

service.interceptors.request.use(config => {
    config.headers = {
        Authorization : `Bearer ${user ? user.token : null}`
    }
    return config;
});

export { service };